import React from 'react';
import { PageHero } from '../components/PageHero';
import { FounderProfile } from '../components/FounderProfile';
import { History } from '../components/History';
import { SectionStage } from '../components/SectionStage';
export function AboutPage() {
  return <>
      <PageHero eyebrow="About" title="Periscan is not new." titleMuted="It's back." description="Founded in 2004 by Sean Heiney, Periscan was built around a simple idea: security assessment should be continuous. The market caught up. Now the original founder is bringing it back for the AI era." bg="none" data-id="element-1459" />
      <SectionStage fx="glow-orbs" data-id="element-1460">
        <FounderProfile data-id="element-1461" />
      </SectionStage>
      <SectionStage fx="orbit" data-id="element-1462">
        <History data-id="element-1463" />
      </SectionStage>
    </>;
}